import React, { useEffect, useState } from 'react';
import { Button, Card, ListGroup, Pagination } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { allAnnouncements } from '../../actions/announcementAction';
import Loader from '../Loader';
import Message from '../Message';
import Paginate3 from './Paginate3';

const HomeAnnouncements = () => {
  // const keyword = match.params.keyword;
  // const pageNumber = match.params.pageNumber || 0;
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(0);

  const announcementAll = useSelector((state) => state.announcementAll);
  const { loading, error, announcements, totalPages, currentPage } =
    announcementAll;

  // Same summary-not-browser reasoning as the event lists beside it.
  const VISIBLE_COUNT = 5;
  const [showAll, setShowAll] = useState(false);
  const items = announcements || [];
  const shownAnnouncements = showAll ? items : items.slice(0, VISIBLE_COUNT);

  const checkChapter = window.location.host;

  useEffect(() => {
    dispatch(allAnnouncements(checkChapter, '', pageNumber)); // Done
  }, [dispatch, checkChapter, pageNumber]);
  // console.log(cMembers);
  const changePageNumber = (changePageNumber) => {
    setPageNumber(changePageNumber);
  };

  return (
    <Card className='mb-2'>
      <Card.Header className='text-info text-center' as='h4'>
        Announcements
      </Card.Header>

      <>
        {loading ? (
          <Loader />
        ) : error ? (
          <Message variant='danger'>{error}</Message>
        ) : (
          <>
            <ListGroup variant='flush'>
              {shownAnnouncements.map((announcement, index) => (
                <ListGroup.Item key={index} className='list-group-item-action'>
                  <Link
                    className='d-block'
                    to={`/announcements/${announcement.announcementId}`}
                  >
                    <span className='text-info'> {announcement.title}</span>
                  </Link>
                </ListGroup.Item>
              ))}
            </ListGroup>
            {items.length > VISIBLE_COUNT && (
              <div className='text-center pb-2'>
                <Button
                  variant='link'
                  size='sm'
                  className='text-info p-0'
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? 'Show less' : 'Show more'}
                </Button>
              </div>
            )}
            {/* <HomePaginate totalPages={totalPages} currentPage={currentPage} /> */}
            <div className='align-middle'>
              {totalPages > 1 && (
                <Pagination size='sm' className='justify-content-center my-1'>
                  <Paginate3
                    totalPages={totalPages}
                    currentPage={currentPage}
                    changePageNumber={changePageNumber}
                  />
                </Pagination>
              )}
            </div>
          </>
        )}
      </>
    </Card>
  );
};

export default HomeAnnouncements;
